import Icon from "@mui/material/Icon";

// Pages
//import Pricing from "layouts/pages/landing-pages/Pricing";
import Home from "pages/Home";
import AboutUs from "pages/AboutUs";
import Booking from "pages/Booking";
import Employee from "pages/Employee";
import Employer from "pages/Employer";
import ContactUs from "pages/ContactUs";
import TermsAndConditions from "pages/Terms";
import { PrivacyPolicyPage } from "pages/Privacy";
import { DisclaimerPage } from "pages/Disclaimer";
import Nanny from "pages/Nanny";
import House from "pages/House";
import Car from "pages/Car";
import Land from "pages/Land";
import Driver from "pages/Driver";
import Housekeeper from "pages/Housekeeper";
import HousekeeperChef from "pages/HousekeeperChef";
import Maid from "pages/Maid";

const routes = [
  {
    name: "HOME",
    icon: <Icon>home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    name: "ABOUT",
    icon: <Icon>info</Icon>,
    route: "/about",
    component: <AboutUs />,
  },
  {
    name: "CONTACT",
    icon: <Icon>contact_mail</Icon>,
    route: "/contact",
    component: <ContactUs />,
  },
  {
    route: "/employer",
    component: <Employer />,
  },
  {
    route: "/services/booking",
    component: <Booking />,
  },
  {
    route: "/services/housekeeper",
    component: <Housekeeper />,
  },
  {
    route: "/services/maid",
    component: <Maid />,
  },
  {
    route: "/services/chef",
    component: <HousekeeperChef />,
  },
  {
    route: "/services/driver",
    component: <Driver />,
  },
  {
    route: "/services/nanny",
    component: <Nanny />,
  },
  {
    route: "/services/land",
    component: <Land />,
  },
  {
    route: "/services/house",
    component: <House />,
  },
  {
    route: "/services/car",
    component: <Car />,
  },
  {
    route: "/employee",
    component: <Employee />,
  },
  {
    route: "/terms-condtions",
    component: <TermsAndConditions />,
  },
  {
    route: "/privacy-policy",
    component: <PrivacyPolicyPage />,
  },
  {
    route: "/disclaimer",
    component: <DisclaimerPage />,
  },
];

export default routes;
